// Fetch availability
export const ASTRAL_AVAILABILITY_REQUEST = 'ASTRAL_AVAILABILITY_REQUEST';
export const astralAvailabilityRequest = () =>
  ({ type: ASTRAL_AVAILABILITY_REQUEST });

export const ASTRAL_AVAILABILITY_SUCCESS = 'ASTRAL_AVAILABILITY_SUCCESS';
export const astralAvailabilitySuccess = (available) =>
  ({ type: ASTRAL_AVAILABILITY_SUCCESS, payload: { available } });

export const ASTRAL_AVAILABILITY_ERROR = 'ASTRAL_AVAILABILITY_ERROR';
export const astralAvailabilityError = (error) =>
  ({ type: ASTRAL_AVAILABILITY_ERROR, payload: error });

// Calculate (free tier)
export const ASTRAL_CALCULATE_REQUEST = 'ASTRAL_CALCULATE_REQUEST';
export const astralCalculateRequest = (fullName, birthDate, birthTime, birthCity, birthCountry, lat, lng) =>
  ({ type: ASTRAL_CALCULATE_REQUEST, payload: { full_name: fullName, birth_date: birthDate, birth_time: birthTime, birth_city: birthCity, birth_country: birthCountry, lat, lng } });

export const ASTRAL_CALCULATE_SUCCESS = 'ASTRAL_CALCULATE_SUCCESS';
export const astralCalculateSuccess = (reading) =>
  ({ type: ASTRAL_CALCULATE_SUCCESS, payload: { reading } });

export const ASTRAL_CALCULATE_ERROR = 'ASTRAL_CALCULATE_ERROR';
export const astralCalculateError = (error) =>
  ({ type: ASTRAL_CALCULATE_ERROR, payload: error });

// Premium reading
export const ASTRAL_PREMIUM_REQUEST = 'ASTRAL_PREMIUM_REQUEST';
export const astralPremiumRequest = (readingId, email) =>
  ({ type: ASTRAL_PREMIUM_REQUEST, payload: { reading_id: readingId, email } });

export const ASTRAL_PREMIUM_SUCCESS = 'ASTRAL_PREMIUM_SUCCESS';
export const astralPremiumSuccess = (data) =>
  ({ type: ASTRAL_PREMIUM_SUCCESS, payload: { data } });

export const ASTRAL_PREMIUM_ERROR = 'ASTRAL_PREMIUM_ERROR';
export const astralPremiumError = (error) =>
  ({ type: ASTRAL_PREMIUM_ERROR, payload: error });

export const ASTRAL_PREMIUM_PENDING = 'ASTRAL_PREMIUM_PENDING';
export const astralPremiumPending = (etaAt) =>
  ({ type: ASTRAL_PREMIUM_PENDING, payload: { etaAt } });

// Synastry
export const ASTRAL_SYNASTRY_REQUEST = 'ASTRAL_SYNASTRY_REQUEST';
export const astralSynastryRequest = (readingId, partnerName, partnerBirthDate, partnerBirthTime, partnerBirthCity, partnerBirthCountry, partnerLat, partnerLng) =>
  ({ type: ASTRAL_SYNASTRY_REQUEST, payload: { reading_id: readingId, partner_name: partnerName, partner_birth_date: partnerBirthDate, partner_birth_time: partnerBirthTime, partner_birth_city: partnerBirthCity, partner_birth_country: partnerBirthCountry, partner_lat: partnerLat, partner_lng: partnerLng } });

export const ASTRAL_SYNASTRY_SUCCESS = 'ASTRAL_SYNASTRY_SUCCESS';
export const astralSynastrySuccess = (data) =>
  ({ type: ASTRAL_SYNASTRY_SUCCESS, payload: { data } });

export const ASTRAL_SYNASTRY_ERROR = 'ASTRAL_SYNASTRY_ERROR';
export const astralSynastryError = (error) =>
  ({ type: ASTRAL_SYNASTRY_ERROR, payload: error });

// Like
export const ASTRAL_LIKE_REQUEST = 'ASTRAL_LIKE_REQUEST';
export const astralLikeRequest = (readingId, like) =>
  ({ type: ASTRAL_LIKE_REQUEST, payload: { reading_id: readingId, like } });

export const ASTRAL_LIKE_SUCCESS = 'ASTRAL_LIKE_SUCCESS';
export const astralLikeSuccess = () =>
  ({ type: ASTRAL_LIKE_SUCCESS });

// Catalog
export const ASTRAL_CATALOG_REQUEST = 'ASTRAL_CATALOG_REQUEST';
export const astralCatalogRequest = () =>
  ({ type: ASTRAL_CATALOG_REQUEST });

export const ASTRAL_CATALOG_SUCCESS = 'ASTRAL_CATALOG_SUCCESS';
export const astralCatalogSuccess = (planets) =>
  ({ type: ASTRAL_CATALOG_SUCCESS, payload: { planets } });

export const ASTRAL_CATALOG_ERROR = 'ASTRAL_CATALOG_ERROR';
export const astralCatalogError = (error) =>
  ({ type: ASTRAL_CATALOG_ERROR, payload: error });

// Standalone Synastry
export const STANDALONE_SYNASTRY_REQUEST = 'STANDALONE_SYNASTRY_REQUEST';
export const standaloneSynastryRequest = (personA, personB) =>
  ({ type: STANDALONE_SYNASTRY_REQUEST, payload: {
    person_a_name: personA.name, person_a_birth_date: personA.birthDate, person_a_birth_time: personA.birthTime,
    person_a_birth_city: personA.birthCity, person_a_birth_country: personA.birthCountry,
    person_a_lat: personA.lat, person_a_lng: personA.lng,
    person_b_name: personB.name, person_b_birth_date: personB.birthDate, person_b_birth_time: personB.birthTime,
    person_b_birth_city: personB.birthCity, person_b_birth_country: personB.birthCountry,
    person_b_lat: personB.lat, person_b_lng: personB.lng,
  }});

export const STANDALONE_SYNASTRY_SUCCESS = 'STANDALONE_SYNASTRY_SUCCESS';
export const standaloneSynastrySuccess = (data) =>
  ({ type: STANDALONE_SYNASTRY_SUCCESS, payload: { data } });

export const STANDALONE_SYNASTRY_ERROR = 'STANDALONE_SYNASTRY_ERROR';
export const standaloneSynastryError = (error) =>
  ({ type: STANDALONE_SYNASTRY_ERROR, payload: error });

export const STANDALONE_SYNASTRY_RESET = 'STANDALONE_SYNASTRY_RESET';
export const standaloneSynastryReset = () =>
  ({ type: STANDALONE_SYNASTRY_RESET });

// Reset
export const ASTRAL_RESET = 'ASTRAL_RESET';
export const astralReset = () =>
  ({ type: ASTRAL_RESET });

// Anonymous per-reading pending creation (pay-to-generate landing)
export const CREATE_PENDING_ASTRAL_REQUEST = 'ASTRAL/CREATE_PENDING_REQUEST';
export const createPendingAstralRequest = (payload) =>
  ({ type: CREATE_PENDING_ASTRAL_REQUEST, payload });

export const CREATE_PENDING_ASTRAL_SUCCESS = 'ASTRAL/CREATE_PENDING_SUCCESS';
export const createPendingAstralSuccess = (readingId, fullName) =>
  ({ type: CREATE_PENDING_ASTRAL_SUCCESS, payload: { readingId, fullName } });

export const CREATE_PENDING_ASTRAL_FAILURE = 'ASTRAL/CREATE_PENDING_FAILURE';
export const createPendingAstralFailure = (error) =>
  ({ type: CREATE_PENDING_ASTRAL_FAILURE, payload: error });

// Anonymous per-reading checkout
export const ASTRAL_CHECKOUT_REQUEST = 'ASTRAL_CHECKOUT_REQUEST';
export const astralCheckoutRequest = (email, readingId) =>
  ({ type: ASTRAL_CHECKOUT_REQUEST, payload: { email, reading_id: readingId } });

export const ASTRAL_CHECKOUT_SUCCESS = 'ASTRAL_CHECKOUT_SUCCESS';
export const astralCheckoutSuccess = () => ({ type: ASTRAL_CHECKOUT_SUCCESS });
export const ASTRAL_CHECKOUT_FAILURE = 'ASTRAL_CHECKOUT_FAILURE';
export const astralCheckoutFailure = (e) => ({ type: ASTRAL_CHECKOUT_FAILURE, payload: e });

export const ASTRAL_PAYPAL_ORDER_REQUEST = 'ASTRAL_PAYPAL_ORDER_REQUEST';
export const astralPaypalOrderRequest = (email, readingId) =>
  ({ type: ASTRAL_PAYPAL_ORDER_REQUEST, payload: { email, reading_id: readingId } });

export const ASTRAL_PAYPAL_ORDER_SUCCESS = 'ASTRAL_PAYPAL_ORDER_SUCCESS';
export const astralPaypalOrderSuccess = () => ({ type: ASTRAL_PAYPAL_ORDER_SUCCESS });
export const ASTRAL_PAYPAL_ORDER_FAILURE = 'ASTRAL_PAYPAL_ORDER_FAILURE';
export const astralPaypalOrderFailure = (e) => ({ type: ASTRAL_PAYPAL_ORDER_FAILURE, payload: e });

export const ASTRAL_VERIFY_PURCHASE_REQUEST = 'ASTRAL_VERIFY_PURCHASE_REQUEST';
export const astralVerifyPurchaseRequest = (sessionId) =>
  ({ type: ASTRAL_VERIFY_PURCHASE_REQUEST, payload: { session_id: sessionId } });
export const ASTRAL_VERIFY_PURCHASE_SUCCESS = 'ASTRAL_VERIFY_PURCHASE_SUCCESS';
export const astralVerifyPurchaseSuccess = (data) =>
  ({ type: ASTRAL_VERIFY_PURCHASE_SUCCESS, payload: data });
export const ASTRAL_VERIFY_PURCHASE_FAILURE = 'ASTRAL_VERIFY_PURCHASE_FAILURE';
export const astralVerifyPurchaseFailure = (e) => ({ type: ASTRAL_VERIFY_PURCHASE_FAILURE, payload: e });

export const ASTRAL_VERIFY_PAYPAL_REQUEST = 'ASTRAL_VERIFY_PAYPAL_REQUEST';
export const astralVerifyPaypalRequest = (paypalOrderId) =>
  ({ type: ASTRAL_VERIFY_PAYPAL_REQUEST, payload: { paypal_order_id: paypalOrderId } });
export const ASTRAL_VERIFY_PAYPAL_SUCCESS = 'ASTRAL_VERIFY_PAYPAL_SUCCESS';
export const astralVerifyPaypalSuccess = (data) =>
  ({ type: ASTRAL_VERIFY_PAYPAL_SUCCESS, payload: data });
export const ASTRAL_VERIFY_PAYPAL_FAILURE = 'ASTRAL_VERIFY_PAYPAL_FAILURE';
export const astralVerifyPaypalFailure = (e) => ({ type: ASTRAL_VERIFY_PAYPAL_FAILURE, payload: e });
